import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll,ActionSheetController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
import { DatePipe } from '@angular/common';
import { NativeService } from '../../../../service/native.service';
declare var app;
declare var imageConversion;
@Component({
  selector: 'app-mz-sales-report-monthly',
  templateUrl: './mz-sales-report-monthly.component.html',
  styleUrls: ['./mz-sales-report-monthly.component.scss']
})
export class MzSalesReportMonthlyComponent extends GridBaseCase {
  month: any = new Date();
  searchDate = null;
  dataArrayList: Array<any> = [];
  arrayPicture: Array<any> = [];
  arraypicValue:Array<any> = new Array<any>();
  submitArr = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  uploadLoading:boolean = false;//上传加载中
  PID:any = null;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    private nativeservice: NativeService,
    private actionSheet: ActionSheetController
  ) { super(); }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let seaobj={};
    seaobj["FK_SystemUser_ID"]=that.com.GetAccount.Id;
    seaobj["FK_TBStore_ID"]=that.com.GetStorageKey("tbstore")["ID"];
    body.RequestBody = JSON.stringify(seaobj);
    // if (!that.com.GetAccount.IsAdmin) {
    //  console.log(that.month);
    //   if (!that.searchDate) {
    //     let startDate = that.com.getNow.split('-')[0] + "-" + that.com.getNow.split('-')[1] + "-" + "01" + " 00:00:00";
    //     let endDate = that.com.getNow.split('-')[0] + "-" + that.com.getNow.split('-')[1] + "-" + (new Date().getDate()) + " 23:59:59";
    //     that.searchDate = that.com.BetweenDate(startDate, endDate);
    //   }
    //   if (that.searchDate) {
    //     body.RequestBody = JSON.stringify({ "a_ModifyTime": that.searchDate });
    //   }
    // }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
         
          let objfield = { 'num': { 'text': '金额', value: null } };
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.onInput(objfield);
          that.dataArrayList.push(objfield);
        });
        console.log(that.dataArrayList);
        let pics:Array<any> = [];
        that.dataArrayList.forEach(pic=>{
          pics=[];
          if(!that.PID){
            if(pic.pid && pic.pid.value){
              that.PID=pic.pid.value;
            }
          }
          if(pics.length<=0){
            if(pic.pic.value){
              let picd:any = pic.pic.value.split(',');
              picd.forEach(items=>{
                pics.push((app.UPLOADSmallImageURL + items).replace("placeholder/",""));
                that.arraypicValue.push(items);
              });
            }
          }
        })
        that.arrayPicture=pics;
       
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          that.infiniteScroll.disabled = true;
        } else {
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  async pictureEvent() {
    let that = this;
    const actionSheet = await that.actionSheet.create({
      buttons: [{
        text: '拍照',
        icon: 'camera',
        handler: () => {
          // that.nativeservice.getCameraPictureUrl().then((data)=>{
          //   that.uploadLoading = true;
          //   that.nativeservice.UploadFile(data.trim()).then(body=>{
          //     that.uploadLoading= false;
          //     if (body.ResponseMessage.Success) {
          //       console.log("上传" + body);
          //       // that.img_url[that.config.name] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
          //       // that.group.controls[that.config.name].setValue(body.Status[0].FileName);
          //       // that.ImageLoading(that.img_url[that.config.name]);
          //      that.arraypicValue.push(body.Status[0].FileName);
          //       that.arrayPicture.push(app.UPLOADREADURL + body.Status[0].FileName + "&size=t");
          //     } else {
          //       that.msg.Alert(body.ResponseMessage.ErrorMessage);
          //     }
          //   })
          // })
          let quality:any ={};//拍照照片压缩比例
              quality["quality"]=app.quality||15;
          that.nativeservice.getCameraPicture(quality).then((data) => {
            that.uploadLoading = true;
            // console.log("照片地址：" + data);
            let url = "data:image/jpeg;base64," + data;
            imageConversion.dataURLtoFile(url,'image/jpeg').then(file => {
              imageConversion.compressAccurately(file, 600).then(blob => {
                let imgName = that.getFileName();   
                let FileName = "["+imgName+"]"+imgName+".jpg";

                  let formData = new FormData();                                                             
                  formData.append('files',blob,imgName + ".jpg");
                  let store = that.com.GetStorageKey("tbstore");
                  if(store){
                    formData.append('RequestBody',JSON.stringify({"storeId":store.ID,"FileName":FileName}));
                  }else{
                    formData.append('RequestBody',JSON.stringify({"FileName":FileName}));
                  }
                  var request = new XMLHttpRequest();
                  // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
                  request.open('post',app.UPLOADURL,true);
                  // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
                  request.send(formData);
                  request.onload = function(data){
                    that.uploadLoading= false;
                    if(data.currentTarget['status'] == 200){
                      const body = JSON.parse(data.currentTarget['response']);
                      if (body.ResponseMessage.Success) {
                        console.log("上传" + body);
                        // that.img_url[that.config.name] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
                        // that.group.controls[that.config.name].setValue(body.Status[0].FileName);
                        // that.ImageLoading(that.img_url[that.config.name]);
                       that.arraypicValue.push(body.Status[0].FileName);
                        that.arrayPicture.push((app.UPLOADSmallImageURL + body.Status[0].FileName).replace("placeholder/",""));
                      } else {
                        that.msg.Alert(body.ResponseMessage.ErrorMessage);
                      }
                    }else{
                      console.log(data);
                      that.msg.Alert("图片上传失败");
                    }
                  }
              })
            })

            
          }).catch(error => {
            that.msg.Show(error.ErrorMessage);
          })
        }
      }, {
        text: '取消',
        icon: '',
        role: 'cancel',
        handler: () => {
        }
      }]
    });
    await actionSheet.present();
  }
  submit() {
    if (this.submitArr.length == 0) {
      this.msg.Alert("无数据提交");
      return;
    }
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "add";
    body.ConfigType = "form";
    // body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
     console.log(that.month);
      let _obj={};
      if(that.PID){
        _obj["a_ID"]=that.PID;
        body.OpType = "EDITE";
      }
      _obj["a_ReportPicture"]=that.arraypicValue.toString();
      _obj["a_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore").ID;
      _obj["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
      _obj["CHILDOBJ_TBDataReportMonthDetailXML"]={};
      _obj["CHILDOBJ_TBDataReportMonthDetailXML"].Datas=that.submitArr;
      _obj["CHILDOBJ_TBDataReportMonthDetailXML"].Info={"FormFKElementModel":"a_FK_TBDataReportMonth_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TBDataReportMonthDetailXML"};
    body.RequestBody = JSON.stringify(_obj);
    that.msg.Loading("数据请求中...").then(load => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        load.dismiss();
        if (data.ResponseMessage.Success) {
          that.msg.Alert('提交成功！');
          let out = that.com.GetStorageKey("btn");
          if(out){
            that.com.setBadge(out.pagename,out.temp,out.name);
          }
          let datepie: DatePipe = new DatePipe("en-US");
          // let datetime = datepie.transform(new Date(), "yyyyMMddHHmmss") + "&ok";//上班打卡时间
          // that.router.navigate(["tabs/contact/HomeSFA/add/" + that.com.getNowDatetime]);
          that.com.Go("tabs/contact/HomeSFA/add/" + that.com.getNowDatetime);
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.msg.Alert("请求失败,请联系管理员");
        load.dismiss();
      })

      load.present();
    });
  
  }

  onInput(item) {
    //console.log("月数据上报");
    let that = this;
    let arraybolean: boolean = false;
    let datepie: DatePipe = new DatePipe("en-US");
    let datetime = datepie.transform(new Date(), "yyyy-MM-dd");//上班打卡时间
    if (item['num'].value != null) {
      // item['num'].value = parseInt(item['num'].value,2);
      if (this.submitArr.length == 0) {
        let obj = {};
        if(item.mid.value){
          obj['a_ID'] = item.mid.value;
        }
        obj['a_FK_TBProductBrand_ID'] = item['ID'].value;
        obj['a_Amount'] = item['num'].value;
        obj["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
        that.submitArr.push(obj);
      } else {
        this.submitArr.forEach(function (ele, index) {
          if (ele['a_FK_TBProductBrand_ID'] == item['ID'].value) {
            arraybolean = true;
            ele['a_Amount'] = item['num'].value;
          }
        });
        if (!arraybolean) {
          let obj = {};
          if(item.mid.value){
            obj['a_ID'] = item.mid.value;
          }
          obj['a_FK_TBProductBrand_ID'] = item['ID'].value;
          obj['a_Amount'] = item['num'].value;
          obj["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
          that.submitArr.push(obj);
        }
      }
    }
  }

  btnUserEvent(index: number) {
    const that = this;
    console.log(index);
    that.msg.Confirm("确定删除此照片吗？").then((data) => {
      that.arrayPicture.splice(index, 1);
      that.arraypicValue.splice(index,1);
    })
  }


  ImgPreview(index) {
    let that = this;
      const url: Array<any> = [];
      that.arrayPicture.forEach(item => {
          let urls = item.trim().replace("thumbnails", "images");
          url.push(urls);
    });
    let ImgPreview = {
      imgUrl:url,
      index:index
    }
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    // that.router.navigate(["/tabs/contact/ImgPreview"],{
    //   queryParams:{
    //     ImgPreview:JSON.stringify(ImgPreview)
    //   }
    // });
    that.com.Go("/tabs/contact/ImgPreview",{
      ImgPreview:JSON.stringify(ImgPreview)
    });
  }
  async EditImg(index:number) {
    const that = this;
    const pageType = that.activaRouter.snapshot.paramMap.get('type');
    if(pageType=="view"){
      that.ImgPreview(index);
      return;
    }
    const actionSheet = await this.actionSheet.create({
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          that.ImgPreview(index);
        }
      }, {
        text: '删除',
        handler: () => {
          that.arrayPicture.splice(index, 1);
          that.arraypicValue.splice(index,1);
          // let _obj = null;
          // let _newobj = null;
          // let templateName = that.template.name;
          // let Name = that.config.name;
          // that.group.removeControl[that.config.name];
          // that.img_url[that.config.name] = null;
          // _obj = localStorage.getItem(templateName);
          // if (_obj) {
          //   _newobj = JSON.parse(localStorage.getItem(templateName)) || {};
          //   delete _newobj[Name];
          // }
          // localStorage.setItem(templateName, JSON.stringify(_newobj));
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }
  getFileName(){
    let date:Date = new Date();
    let year,month,day;
    let arrayday = date.toLocaleDateString().split("/");
    let riqi = date.getFullYear().toString().substring(2,4);
    let tmp1:any = date.getMonth()+1;
    let tmp2:any =  date.getDate();
    month=tmp1;
    day = tmp2;
    if(tmp1 <10){
      month = "0"+tmp1;
    }
    if(tmp2<10){
      day = "0"+tmp2;
    }
    year = riqi;
      return year+month+day+date.getHours()+date.getMinutes()+date.getSeconds()+date.getMilliseconds();

  }
}
